import { render, staticRenderFns } from "./TransferRecord.vue?vue&type=template&id=2440f15e&scoped=true"
import script from "./TransferRecord.vue?vue&type=script&lang=js"
export * from "./TransferRecord.vue?vue&type=script&lang=js"
import style0 from "./TransferRecord.vue?vue&type=style&index=0&id=2440f15e&prod&scoped=true&lang=css"
import style1 from "./TransferRecord.vue?vue&type=style&index=1&id=2440f15e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2440f15e",
  null
  
)

export default component.exports